/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useState } from 'react';
import { FileText, RefreshCw } from 'lucide-react';
import { chamarApi } from '@/nucleo/auth/cliente-api';
import { Button } from '@/ui/base/button';
const NS = '/bff/v1/j08-s07-consultar-credenciado',
  moeda = (v: any) => Number(v).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
export function DemonstrativosPagamentoPage() {
  const [s, setS] = useState<any>();
  async function call(p = '/state') {
    const r = await chamarApi<any>(NS + p, { metodo: p === '/state' ? 'GET' : 'POST' });
    setS(r.state);
  }
  useEffect(() => {
    void call();
  }, []);
  if (!s)
    return (
      <main role="status" className="p-6">
        Carregando demonstrativos…
      </main>
    );
  return (
    <main className="min-w-0 max-w-[calc(100vw-2rem)] space-y-5 overflow-hidden">
      <header>
        <h1 className="text-3xl font-semibold">
          <FileText className="mr-2 inline h-7 w-7" />
          {s.titulo}
        </h1>
        <p>{s.descricao}</p>
      </header>
      {s.demonstrativos.length === 0 ? (
        <p>Nenhum demonstrativo final foi publicado para seu cadastro.</p>
      ) : (
        s.demonstrativos.map((d: any) => (
          <article className="space-y-2 rounded-md border p-4" key={d.id}>
            <h2 className="font-semibold">
              {d.numero} · versão {d.versao}
            </h2>
            <p>
              Bruto {moeda(d.bruto)} · ajustes {moeda(d.ajustes)} · glosas {moeda(d.glosas)}
            </p>
            <p>
              Retenções {moeda(d.retencoes)} · exceções {moeda(d.excecoes)} · movimentos posteriores{' '}
              {moeda(d.movimentos_adicionais)}
            </p>
            <p className="text-lg font-semibold">Líquido {moeda(d.liquido)}</p>
            <p className="break-all font-mono text-xs">Documento imutável: {d.hash}</p>
          </article>
        ))
      )}
      <Button variant="outline" onClick={() => void call('/verbs/recarregar')}>
        <RefreshCw className="mr-2 h-4 w-4" />
        Atualizar documentos
      </Button>
    </main>
  );
}
